export default __webpack_public_path__ + "static/6-400e96a2c706b7e5563667c5762f83ac.jpg";